import React from 'react';
import { NavLink } from 'react-router-dom';

const services = [
    {
        count: 1,
        title: `Construction & Site Execution`,
        icon: require('./../../images/icon/crane-1.png'),
        description: 'Managing commercial and institutional construction works with strong coordination, quality control, and predictable delivery.',
    },
    {
        count: 2,
        title: 'Renovation, upgrade & Refurbishment',
        icon: require('./../../images/icon/renovation.png'),
        description: 'Upgrading existing spaces with improved function, refined finishes, and a delivery approach minimizing disruption.',
    },
    {
        count: 3,
        title: 'Interior Fit-Out & Finishes',
        icon: require('./../../images/icon/compass.png'),
        description: 'Creating polished interiors for offices, branches, and commercial environments with attention to detail and finish quality.',
    },
    {
        count: 4,
        title: 'Computer Networking & Structured Cabling',
        icon: require('./../../images/icon/toolbox.png'),
        description: 'Secure connectivity, reliable cabling, and infrastructure supporting offices, branches, and data-sensitive spaces.',
    }
]

var img1 = require('./../../images/background/bg-6.png');

class OurServices extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding  p-b50  square_shape2">
                    <div className="section-content">
                        <div className="Service-half-top p-t80  bg-dark bg-moving" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                            <div className="container">
                                {/* TITLE START */}
                                <div className="section-head text-white">
                                    <div className="mt-separator-outer separator-left">
                                        <div className="mt-separator">
                                            <h2 className="text-white text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Services</h2>
                                        </div>
                                    </div>
                                    <h3>Integrated delivery for construction, interior fit-outs, refurbishment, and networking infrastructure across commercial and banking environments.</h3>
                                </div>
                                {/* TITLE END */}
                            </div>
                        </div>
                        <div className="services-half-bottom">
                            <div className="container">
                                <div className="row">
                                    {services.map((item, index) => (
                                        <div className="col-md-3 col-sm-6" key={index}>
                                            <div className="mt-icon-box-wraper m-b30">
                                                <div className="relative icon-count-2 bg-gray p-a30 p-tb50">
                                                    <span className="icon-count-number">{item.count}</span>
                                                    <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                        <span className="icon-cell"><img src={item.icon} alt="" /></span>
                                                    </div>
                                                    <div className="icon-content">
                                                        <h4 className="mt-tilte m-b25">{item.title}</h4>
                                                        <p>{item.description}</p>
                                                        <NavLink to={"/services"} className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
};

export default OurServices;